const ROOT_ID = "auditbadger-easter-egg-root";
const STYLE_ID = "auditbadger-easter-egg-style";
const TRIGGER_WORD = "badger";
const BOMB_WORD = "badgers";
const SINGLE_DELAY_MS = 260;
const BOMB_GRACE_MS = 1400;
const SINGLE_DURATION_MS = 8800;
const BOMB_DURATION_MS = 11800;
const Z_INDEX = 2147483000;
const STATE_KEY = "__auditBadgerEasterEgg";
const AUDIO_ID = "auditbadger-easter-egg-audio";

let typedBuffer = "";
let singleTimer = null;
let bufferResetTimer = null;

function easterEggState() {
  window[STATE_KEY] ||= {
    installed: false,
  };

  return window[STATE_KEY];
}

function assetConfig() {
  return {
    badgerSrc: document.body?.dataset.auditbadgerBadgerSrc,
    musicSrc: document.body?.dataset.auditbadgerMusicSrc,
  };
}

function prefersReducedMotion() {
  return window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
}

function ensureStyles() {
  if (document.getElementById(STYLE_ID)) return;

  const style = document.createElement("style");
  style.id = STYLE_ID;
  style.textContent = `
#${ROOT_ID} {
  position: fixed;
  inset: 0;
  z-index: ${Z_INDEX};
  pointer-events: none;
  overflow: hidden;
}

#${ROOT_ID} .ab-sleep-button {
  pointer-events: auto;
  position: absolute;
  right: max(18px, env(safe-area-inset-right));
  bottom: max(18px, env(safe-area-inset-bottom));
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  max-width: calc(100vw - 36px);
  border: 1px solid rgb(255 255 255 / 0.34);
  border-radius: 16px;
  padding: 12px 16px;
  color: #fffdfa;
  background:
    linear-gradient(135deg, rgb(59 39 144 / 0.92), rgb(17 17 24 / 0.92));
  box-shadow: 0 18px 48px rgb(15 15 20 / 0.28);
  font: inherit;
  text-align: left;
  cursor: pointer;
  backdrop-filter: blur(14px);
}

#${ROOT_ID} .ab-sleep-button:hover {
  transform: translateY(-1px);
  box-shadow: 0 22px 54px rgb(15 15 20 / 0.34);
}

#${ROOT_ID} .ab-sleep-button:focus-visible {
  outline: 3px solid rgb(255 255 255 / 0.76);
  outline-offset: 3px;
}

#${ROOT_ID} .ab-sleep-button-main {
  font-size: 14px;
  font-weight: 800;
  line-height: 1.2;
}

#${ROOT_ID} .ab-sleep-button-note {
  color: rgb(255 253 250 / 0.74);
  font-size: 11px;
  font-weight: 650;
  line-height: 1.2;
}

#${ROOT_ID} .ab-badger {
  position: absolute;
  left: var(--ab-left, 50%);
  top: var(--ab-top, 50%);
  width: clamp(96px, 17vw, 190px);
  opacity: 0;
  filter: drop-shadow(0 22px 16px rgb(15 15 20 / 0.24));
  transform-origin: center bottom;
  animation: ab-badger-roam var(--ab-duration, ${BOMB_DURATION_MS}ms) ease-in-out var(--ab-delay, 0ms) infinite;
}

#${ROOT_ID} .ab-badger img {
  display: block;
  width: 100%;
  height: auto;
  user-select: none;
}

#${ROOT_ID}.ab-single .ab-badger {
  left: 50%;
  top: auto;
  bottom: max(24px, env(safe-area-inset-bottom));
  width: clamp(144px, 26vw, 280px);
  animation-name: ab-badger-single;
}

#${ROOT_ID}.ab-single .ab-sleep-button {
  left: 50%;
  right: auto;
  transform: translateX(-50%);
}

#${ROOT_ID}.ab-single .ab-sleep-button:hover {
  transform: translateX(-50%) translateY(-1px);
}

#${ROOT_ID}.ab-reduced-motion .ab-badger {
  left: 50%;
  top: 50%;
  bottom: auto;
  width: clamp(128px, 34vw, 240px);
  opacity: 1;
  animation: none;
  transform: translate(-50%, -50%);
}

@media (max-width: 640px) {
  #${ROOT_ID} .ab-sleep-button,
  #${ROOT_ID}.ab-single .ab-sleep-button {
    left: 18px;
    right: 18px;
    bottom: max(14px, env(safe-area-inset-bottom));
    align-items: center;
    text-align: center;
    transform: none;
  }

  #${ROOT_ID} .ab-sleep-button:hover,
  #${ROOT_ID}.ab-single .ab-sleep-button:hover {
    transform: translateY(-1px);
  }
}

@keyframes ab-badger-roam {
  0% {
    opacity: 0;
    transform: translate(-50%, -50%) translate(0, 22px) scale(var(--ab-scale, 1)) rotate(-5deg);
  }
  12%,
  82% {
    opacity: 1;
  }
  46% {
    transform: translate(-50%, -50%) translate(var(--ab-drift-x, 0), var(--ab-drift-y, -18px)) scale(var(--ab-scale, 1)) rotate(5deg);
  }
  100% {
    opacity: 0;
    transform: translate(-50%, -50%) translate(var(--ab-drift-x-end, 0), 34px) scale(var(--ab-scale, 1)) rotate(-4deg);
  }
}

@keyframes ab-badger-single {
  0% {
    opacity: 0;
    transform: translateX(-50%) translateY(28px) scale(0.82) rotate(-4deg);
  }
  12%,
  86% {
    opacity: 1;
  }
  44% {
    transform: translateX(-50%) translateY(-10px) scale(1.04) rotate(3deg);
  }
  100% {
    opacity: 0;
    transform: translateX(-50%) translateY(18px) scale(0.96) rotate(-2deg);
  }
}
`;

  document.head.appendChild(style);
}

function randomBetween(min, max) {
  return min + Math.random() * (max - min);
}

function bombCount() {
  return 10 + Math.floor(Math.random() * 5);
}

function stopMusic() {
  const audio = document.getElementById(AUDIO_ID);
  if (!(audio instanceof HTMLAudioElement)) return;

  audio.pause();
  audio.currentTime = 0;
  audio.remove();
}

function playMusic() {
  const { musicSrc } = assetConfig();
  if (!musicSrc) return;

  const existingAudio = document.getElementById(AUDIO_ID);
  if (existingAudio instanceof HTMLAudioElement) {
    if (existingAudio.dataset.auditbadgerState === "starting" || !existingAudio.paused) return;

    existingAudio.remove();
  }

  const audio = document.createElement("audio");
  audio.id = AUDIO_ID;
  audio.src = musicSrc;
  audio.loop = true;
  audio.volume = 0.68;
  audio.preload = "auto";
  audio.dataset.auditbadgerState = "starting";
  document.body.appendChild(audio);

  audio
    .play()
    .then(() => {
      audio.dataset.auditbadgerState = "playing";
    })
    .catch(() => {
      audio.dataset.auditbadgerState = "failed";
      audio.remove();
    });
}

function removeOverlay() {
  document.getElementById(ROOT_ID)?.remove();
}

function stop() {
  window.clearTimeout(singleTimer);
  window.clearTimeout(bufferResetTimer);
  singleTimer = null;
  bufferResetTimer = null;
  typedBuffer = "";
  removeOverlay();
  stopMusic();
}

function clearTypedBuffer() {
  window.clearTimeout(bufferResetTimer);
  bufferResetTimer = null;
  typedBuffer = "";
}

function scheduleTypedBufferReset() {
  window.clearTimeout(bufferResetTimer);
  bufferResetTimer = window.setTimeout(clearTypedBuffer, BOMB_GRACE_MS);
}

function addSleepButton(root) {
  const button = document.createElement("button");
  button.type = "button";
  button.className = "ab-sleep-button";
  button.setAttribute("aria-label", "Put the badgers to sleep");
  button.innerHTML = `
    <span class="ab-sleep-button-main">Tuck the badgers in</span>
    <span class="ab-sleep-button-note">End the compliance dance party</span>
  `;
  button.addEventListener("click", stop);

  root.appendChild(button);
}

function createRoot(mode, reducedMotion) {
  removeOverlay();
  ensureStyles();

  const root = document.createElement("div");
  root.id = ROOT_ID;
  root.className = `ab-${mode}`;
  if (reducedMotion) root.classList.add("ab-reduced-motion");

  document.body.appendChild(root);
  addSleepButton(root);
  return root;
}

function addBadger(root, badgerSrc, index, duration) {
  const badger = document.createElement("div");
  const driftX = randomBetween(-90, 90);

  badger.className = "ab-badger";
  badger.style.setProperty("--ab-left", `${randomBetween(7, 93)}%`);
  badger.style.setProperty("--ab-top", `${randomBetween(12, 82)}%`);
  badger.style.setProperty("--ab-scale", randomBetween(0.62, 1.18).toFixed(2));
  badger.style.setProperty("--ab-drift-x", `${driftX}px`);
  badger.style.setProperty("--ab-drift-x-end", `${driftX * 1.35}px`);
  badger.style.setProperty("--ab-drift-y", `${randomBetween(-46, 28)}px`);
  badger.style.setProperty("--ab-delay", `${index * -120}ms`);
  badger.style.setProperty("--ab-duration", `${duration}ms`);

  const image = document.createElement("img");
  image.src = badgerSrc;
  image.alt = "";
  image.draggable = false;

  badger.appendChild(image);
  root.appendChild(badger);
}

function showBadgers({ count, mode, duration, playAudio = true } = {}) {
  const { badgerSrc } = assetConfig();
  if (!badgerSrc || !document.body) return;

  const reducedMotion = prefersReducedMotion();
  const root = createRoot(mode || "single", reducedMotion);
  const visibleCount = reducedMotion ? 1 : Math.max(1, count || 1);

  for (let index = 0; index < visibleCount; index += 1) {
    addBadger(root, badgerSrc, index, duration || SINGLE_DURATION_MS);
  }

  if (playAudio) playMusic();
}

function scheduleSingleBadger() {
  window.clearTimeout(singleTimer);
  scheduleTypedBufferReset();
  singleTimer = window.setTimeout(() => {
    singleTimer = null;
    showBadgers({
      count: 1,
      mode: "single",
      duration: SINGLE_DURATION_MS,
    });
  }, SINGLE_DELAY_MS);
}

function badgerBomb() {
  window.clearTimeout(singleTimer);
  singleTimer = null;
  clearTypedBuffer();
  showBadgers({
    count: bombCount(),
    mode: "bomb",
    duration: BOMB_DURATION_MS,
  });
}

function typingTarget(event) {
  const target = event.target;
  if (!(target instanceof Element)) return false;

  const tagName = target.tagName.toLowerCase();
  return (
    tagName === "input" ||
    tagName === "textarea" ||
    tagName === "select" ||
    target.isContentEditable ||
    Boolean(target.closest("[contenteditable='true']"))
  );
}

function handleKeydown(event) {
  if (event.key === "Escape") {
    stop();
    return;
  }

  if (
    event.defaultPrevented ||
    event.metaKey ||
    event.ctrlKey ||
    event.altKey ||
    typingTarget(event) ||
    !event.key ||
    event.key.length !== 1
  ) {
    return;
  }

  typedBuffer = `${typedBuffer}${event.key.toLowerCase()}`.slice(-BOMB_WORD.length);

  if (typedBuffer.endsWith(BOMB_WORD)) {
    badgerBomb();
    return;
  }

  if (typedBuffer.endsWith(TRIGGER_WORD)) {
    scheduleSingleBadger();
  } else {
    window.clearTimeout(bufferResetTimer);
    bufferResetTimer = null;
  }
}

function start(options = {}) {
  showBadgers({
    count: options.count || 1,
    mode: (options.count || 1) > 1 ? "bomb" : "single",
    duration: options.duration || SINGLE_DURATION_MS,
    playAudio: options.playAudio,
  });
}

function install() {
  const state = easterEggState();
  if (state.installed) return;

  state.installed = true;
  document.addEventListener("keydown", handleKeydown);
  document.addEventListener("turbo:before-cache", stop);
  window.auditBadger = {
    start,
    bomb: badgerBomb,
    stop,
  };
}

install();
